angular.module('listingOverviewModule').component('listingAreaMap', {
    templateUrl: 'listingAreaMap/listingAreaMap.html',
    bindings: {
		listingPopupUrl: '@',
        latitude: '@',
        longitude: '@',
        rpcUrl: '@',
        buildingToken: '@',
        googleMapsKey: '@',
        markerIcon: '@',
        aerialImageUrl: '@',
        streetViewRpc: '@'
    },
    controller: ['$element', '$timeout', function ($element, $timeout) {
        var self = this;
        this._activeLink = null;

        // Initialize maps only when the component is visible
        this.checkVisibilityAndInit = function () {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.addMaps();
                        observer.disconnect(); // Stop observing after initialization
                    }
                });
            });

            observer.observe($element[0]);
        };

        // Switch Tabs Logic
        this.addMaps = function () {
            const mapsElement = $element[0].querySelector('.listing-area-map');
            if (!mapsElement) return;

            const mapLinks = mapsElement.querySelectorAll('.view-picker a');
            const buildingMapElement = mapsElement.querySelector('.building-map');
            const buildingStreetViewElement = mapsElement.querySelector('.building-street-view-map');

            mapLinks.forEach((link) => {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (self._activeLink === link) return;

                    // Deselect previous active link
                    if (self._activeLink) {
                        self._activeLink.classList.remove('selected');
                        if (self._activeLink.map) {
                            self._activeLink.map.classList.remove('active');
                        }
                    }

                    // Hide all circle-link-icons
                    mapsElement.querySelectorAll('.circle-link-icon').forEach((icon) => {
                        icon.style.display = 'none';
                    });

                    // Handle map-specific popup logic
                    let map;
                    if (link.getAttribute('data-map') === 'building-map') {
                        map = mapsElement.querySelector('.map-link');
                    } else if (link.getAttribute('data-map') === 'street-view-map') {
                        map = mapsElement.querySelector('.streetview-link');
                    }

                    if (map) {
                        map.style.display = 'block';
                    }

                    // Load and activate the selected map
                    if (!link.map || link.getAttribute('data-map') === 'street-view-map') {
                        link.map = self['load_' + link.getAttribute('data-map').replace(/-/g, '_')]();
                    }

                    link.classList.add('selected');
                    if (link.map) {
                        link.map.classList.add('active');
                    }

                    self._activeLink = link;
                });
            });

            if (buildingMapElement) {
                buildingMapElement.addEventListener('click', (event) => {
                    const isViewToggler = event.target.closest('.view-picker a');
                    if (!isViewToggler) {
                        self.showListingPopup('map');
                    }
                });
            }
            
            if (buildingStreetViewElement) {
                buildingStreetViewElement.addEventListener('click', (event) => {
                    const isViewToggler = event.target.closest('.view-picker a');
                    if (!isViewToggler) {
                        self.showListingPopup('streetview');
                    }
                });
            }

            // Trigger the first tab click by default
            if (mapLinks.length > 0) {
                mapLinks[0].click();
            }
        };

        // Load the building map
        this.load_building_map = function () {
            const buildingMapElement = $element[0].querySelector('.building-map');
            if (!buildingMapElement) return null;

            const lat = parseFloat(self.latitude);
            const lng = parseFloat(self.longitude);

            new SimpleMap(buildingMapElement, {
                lat: lat,
                lng: lng,
                zoom: 15,
                zoom_control: false,
                scrollwheel: false,
                transit_layer: true,
                onMapReady: function () {
                    this.add_marker({
                        lat: lat,
                        lng: lng,
                        icon: self.markerIcon,
                    });
                },
            });

            return buildingMapElement;
        };

        // Load the street view map
        this.load_street_view_map = function () {
            const streetViewMapElement = $element[0].querySelector('.building-street-view-map');
            if (!streetViewMapElement) return null;

            new Streetview(streetViewMapElement, { zoomControl: false });
            _gaq.push(['_trackEvent', 'Maps', 'Building', 'Streetview']);

            return streetViewMapElement;
        };

        this.openAerialView = function (e) {
            var aerialViewTabs = document.querySelectorAll('.lst_links .aerial_view');
            if (!aerialViewTabs.length) {
                self.showListingPopup();
                return;
            }
            aerialViewTabs.forEach(function(aerialViewTab) {
                aerialViewTab.click();
            });
        };
        // Initialize component
        this.$onInit = function () {
            $timeout(() => {
                this.checkVisibilityAndInit();
            });
        };

		this.showListingPopup = function(tab = 'aerial_view') {
			if (self.listingPopupUrl) {
				$element.blimp = new BlimpExtV2(null, {
					cache: false,
					draggable: true,
					show_veil: true,
					display: tab,
					fullscreen: true,
					rpc_url: self.listingPopupUrl,
					onFetch: function() {
						_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
					},
					onPostRpc: function() {
						this.add_extra(true);

						Core.compile_html(this._element);
					}
				});
				$element.blimp.handle_link_click();
			}
		};

    }],
});
